export const sendTelegramMessage = async (chatId, message, inlineKeyboard) => {
    // const token = process.env.REACT_APP_TELEGRAM_BOT_TOKEN;
    const token = "7409594499:AAH8dqbnrghSJt45yFNDLAnHdWRgcYJ3IvU"
    const url = `https://api.telegram.org/bot${token}/sendMessage`;

    if (!token || !chatId) {
        console.error('Token or chatId is missing');
        return;
    }

    const body = {
        chat_id: chatId,
        text: message,
        // parse_mode: 'Markdown'
    };

    if (inlineKeyboard) {
        body.reply_markup = {
            inline_keyboard: inlineKeyboard
        };
    }

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(body)
        });
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
    } catch (error) {
        console.error("Error sending message to Telegram", error);
    }
}